import { render } from "./SelecionarFuncao.vue?vue&type=template&id=191f90bb&scoped=true&ts=true"
import script from "./SelecionarFuncao.vue?vue&type=script&lang=ts"
export * from "./SelecionarFuncao.vue?vue&type=script&lang=ts"

import "./SelecionarFuncao.vue?vue&type=style&index=0&id=191f90bb&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191f90bb"]])

export default __exports__